var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarningInvoiceGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z",
    fill: "#3355F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3786_74628)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.2826 8.29535C13.6884 5.92813 11.2877 4.49085 8.92051 5.08508C7.07059 5.54947 5.72734 7.14832 5.58894 9.0506C4.27542 9.26721 3.38619 10.5076 3.60281 11.8211C3.79537 12.9889 4.8072 13.8441 5.99068 13.8394H7.99939V13.0359H5.99068C5.10319 13.0359 4.38372 12.3164 4.38372 11.4289C4.38372 10.5414 5.10319 9.82194 5.99068 9.82194C6.21257 9.82194 6.39243 9.64209 6.39243 9.4202C6.39042 7.42332 8.0076 5.80289 10.0045 5.80091C11.7331 5.79918 13.2211 7.02122 13.5555 8.71715C13.5885 8.88648 13.7259 9.01585 13.897 9.03854C14.9953 9.19495 15.7588 10.2121 15.6024 11.3104C15.462 12.2966 14.6199 13.0309 13.6238 13.0359H12.0168V13.8394H13.6238C15.1769 13.8347 16.4322 12.5718 16.4274 11.0187C16.4235 9.7258 15.5386 8.60215 14.2826 8.29535Z",
    fill: "#F0F2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.72415 8.82936L8.11719 10.4363L8.68364 11.0028L9.60765 10.0828V13.9355H10.4111V10.0828L11.3311 11.0028L11.8976 10.4363L10.2906 8.82936C10.1339 8.67358 9.88086 8.67358 9.72415 8.82936Z",
    fill: "#F0F2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3786_74628"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.57031,
    y: 3.57031,
    width: 12.8571,
    height: 12.8571,
    rx: 5.88235,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarningInvoiceGroup);
export default __webpack_public_path__ + "static/media/earning-invoice-group.8ab2ebc772a87113a7dccc169ac02e1c.svg";
export { ForwardRef as ReactComponent };